import { fingerprintInit } from '@sunbit-dev/common/services/fingerprint';
import { samplingInit } from '@sunbit-dev/common/services/sampling';
import { visitId } from '@sunbit-dev/common/services/visitId';
import deviceId from '@sunbit-dev/common/services/deviceId';

export const initFingerprint = async (configService) => {
  const sampling = await samplingInit(configService.getItem('sampling'), {
    application: configService.getItem('application'),
    env: window.sunbitEnv,
    deviceId,
    visitId,
  });

  fingerprintInit(configService.getItem('fingerprintjs')).then((fingerprint) => {
    const { visitorId, requestId } = fingerprint.getFingerprintResult();
    sampling.setCommonDataKey('fingerprintjs', { visitorId, requestId });
    sampling.event('apply-online app started', {});
  });
};
